<template lang="pug">
GenericCard(size='75')
  .sticky-top.bg-white
    .d-flex.justify-content-between.px-4.py-4
      div
        .text-title ประวัติการเข้าเยี่ยม

        .d-flex.align-items-center.mt-2
          .text-medium รายงานการเข้าเยี่ยมวันที่
          CustomDatePicker.ml-3(v-model='filterDate')

      .amount.rounded-circle
        template(v-if="listData.length < 100") {{listData.length}}
        template(v-else) 99+

    hr.m-0

  //- template(v-if='isSubmitted === false')
  .visit-log.px-4.py-4
    .img-grid.w-100
      template(v-for='data in listData')
        .card.shadow.d-flex.flex-column.align-items-center.w-custom-33.m-2(
          style="width: 30%; height: 296px;")
          template(v-if="data.image_path !== null")
            img.check-in-img(
              :src="$api.basePath.replace('api', 'storage') + data.image_path"
              style="max-height: 200px;"
            )
          template(v-else)
            LMap(
              :zoom="15"
              :center="$latLng(data.latitude, data.longitude)"
              style="height: 200px; z-index: 2;"
              :options=`{
                zoomControl: false,
                dragging: false,
                boxZoom: false,
                trackResize: false,
                doubleClickZoom: false,
              }`
            )
              LTileLayer(
                url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              )
              LMarker(
                :lat-lng="$latLng(data.latitude, data.longitude)")
          .text-small.mt-3(style='width: 80%')
            template(v-if='data.user')
              .text-medium
                i.fa.fa-user
                span.ml-2 {{ data.user.name }}
            .d-flex.justify-content-between
              span
                | {{ $moment(data.created_at).format('DD/MM/YY') }}
              span
                | {{ $moment(data.created_at).format('HH:mm') }}
            div(v-if="data.latitude !== null")
              | {{parseFloat(data.latitude).toFixed(6)}},
              |
              | {{parseFloat(data.longitude).toFixed(6)}}

      //- template(v-for='i in [0,1,2,3,4,5,6,7,8]')
      //-   img.check-in-img(:src='`http://placekitten.com/${128+(8*i)}/${128+(8*i)}`')

    //- button.btn.btn-upa-secondary.mx-auto.mb-2(@click='submitLocation')
    //-   | บันทึก

  //- template(v-else)
  //-   .submitted.d-flex.flex-column
  //-     .response-message
  //-       img(src='@/assets/icons/success.svg')
  //-       .text-large.mt-3
  //-         | คุณอัพโหลดภาพสำเร็จแล้ว

</template>

<script>
export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  watch: {
    customer() {
      // console.log(this.customer.id);
      this.loadData();
    },
    filterDate() {
      this.loadData();
    },
  },
  data: () => ({
    isSubmitted: false,
    filterDate: '',

    listData: [],
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      const res = await this.$api.customer.history.getCheckins(
        this.customer.id, { ...this.filterDate },
      );

      if (res.status === 200) {
        this.listData = res.data.data;
      }

      this.isLoading = false;
    },
    submitLocation() {
      // TODO: actually implement the submitting part
      this.isSubmitted = true;
    },
  },
};
</script>

<style lang="scss">
.amount {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  width: 64px;
  background: #0092C9;

  font-size: 32px;
  color: #fff;
}

.visit-log {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FAFAFA;

  .img-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  // .check-in-img {
  //   width: 12vw;
  //   height: 12vw;
  //   background: #E0E0E0;
  //   margin-bottom: 20px;
  // }
}
.response-message {
  min-height: 360px;
  background: #FAFAFA;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
}
</style>
